var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0023 6C11.0391 6 12.0047 6.92913 12.0047 8.23555C12.0047 9.51399 11.077 10.4343 10.0672 10.47C9.4992 10.49 9.00235 10.9523 9.00235 11.5711L9.00235 12.7653C9.00235 13.3176 9.45006 13.7653 10.0023 13.7653C10.5546 13.7653 11.0023 13.3176 11.0023 12.7653V12.3392C12.7684 11.8628 14.0047 10.1581 14.0047 8.23555C14.0047 5.96808 12.2819 4 10.0023 4C7.72278 4 6 5.96808 6 8.23555C6 8.78784 6.44772 9.23555 7 9.23555C7.55228 9.23555 8 8.78784 8 8.23555C8 6.92913 8.96561 6 10.0023 6ZM10.0023 16.0009C10.334 16.0009 10.6028 15.7111 10.6028 15.3538C10.6028 14.9964 10.334 14.7066 10.0023 14.7066C9.67072 14.7066 9.40188 14.9964 9.40188 15.3538C9.40188 15.7111 9.67072 16.0009 10.0023 16.0009Z",
    fill: "#02C3CD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    stroke: "#02C3CD",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/questionIcon.ca9223cd7fabe5cfad13bb9f176c8d65.svg";
export { ForwardRef as ReactComponent };